import { Protocol } from '../Protocol';

export class ExperimentDetectionItemProtocol {
  public static readonly ALL_EXPERIMENT_DETECTION_ITEMS_BY_SEARCH: string = `${Protocol.YATUNG_API_ROOT}/expt/detection/search`;
}
